import React from 'react'

const FacturationDetails = () => {
  return (
    <div>FacturationDetails</div>
  )
}

export default FacturationDetails